<template>
  <div class="my">
    <div class="my-head" v-if="!is_login">
      <!-- <div class="head-img"></div> -->
      <!-- <div class="log-btn"><button @click="login">马上登陆/注册</button></div> -->
    </div>
    <div class="user-info" v-if="is_login">
      <a>
        <div class="my-img">
          <!-- <img src="../../../assets/head.png" /> -->
        </div>
      </a>
      <div class="my-info">
        <p> 电话: {{ userInfo.userName }}</p>
        <p> 积分: {{ inte || 0 }}</p>
      </div>
    </div>
  </div>
</template>
<script>
  import { getToken } from '@/utils/Token'
  // import { getuser } from '@/api/user'
  import { getUserInte } from '@/api/pay'


  export default {
    data() {
      return {
        is_login: false,
        userInfo: {},
        inte: 0
      }
    },
    methods: {
      checklogin() {
        if (getToken('TOKEN') !== null) {
          this.is_login = true
        } else {
          this.is_login = false
        }
      },
      login() {

      },
      async getUserInfo() {
        const result = await this.$store.dispatch('user/getUserInfo')
        this.userInfo = result
      },
      async getInt() {
        const result = await getUserInte()
        this.inte = result.data.data.inte

      }
    },
    created() {
      this.checklogin()
      this.getUserInfo()
      this.getInt()
    }
  }
</script>
<style lang="scss" scoped>
.my {
  font-size: 0.24rem;
  background: url('../../../assets/bg/mybg.jpg') no-repeat;
  // background: #2042db
  background-size: 100%;
  // width: 7.18rem;
  height: 3.3rem;
  // border-radius: 10px;
  margin: auto;

  .my-head {
    vertical-align: baseline;
    height: 100%;

    .head-img {
      width: 1.52rem;
      height: 1.52rem;
      border-radius: 50%;
      background: white;
      margin: auto;
    }

    .log-btn {
      text-align: center;

      button {
        width: 2.34rem;
        height: 0.7rem;
        margin-top: 0.5rem;
        background: #ffc44e;
        color: white;
        border: none;
        border-radius: 30px;
      }
    }
  }

  .user-info {
    display: flex;
    justify-content: start;
    align-items: center;
    padding: 0.3rem;

    .my-img {
      padding: 0.1rem;
      background: #fff;
      border-radius: 50%;
      width: 1.56rem;
      height: 1.56rem;

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }

    .my-info {
      font-size: 0.36rem;
      height: 1rem;
      color: white;
      margin-left: 0.2rem;

      p {
        margin-top: 0;
        margin-bottom: 0.1rem;
      }
    }
  }
}
</style>
